import { Action } from '@ngrx/store';
import { BillingInformation } from './billing';

export const GET_BILLING_INFORMATION = 'GET_BILLING_INFORMATION';
export const GET_BILLING_INFORMATION_SUCCESS = 'GET_BILLING_INFORMATION_SUCCESS';
export const GET_BILLING_INFORMATION_FAILURE = 'GET_BILLING_INFORMATION_FAILURE';
export const UPDATE_BILLING_INFORMATION = 'UPDATE_BILLING_INFORMATION';
export const UPDATE_BILLING_INFORMATION_SUCCESS = 'UPDATE_BILLING_INFORMATION_SUCCESS';
export const UPDATE_BILLING_INFORMATION_FAILURE = 'UPDATE_BILLING_INFORMATION_FAILURE';

export class GetBillingInformationAction implements Action {
  readonly type = GET_BILLING_INFORMATION;

  constructor() {}
}

export class GetBillingInformationSuccessAction implements Action {
  readonly type = GET_BILLING_INFORMATION_SUCCESS;

  constructor(public payload: BillingInformation) {}
}

export class GetBillingInformationFailureAction implements Action {
  readonly type = GET_BILLING_INFORMATION_FAILURE;

  constructor(public payload: any) {}
}

export class UpdateBillingInformationSuccessAction implements Action {
  readonly type = UPDATE_BILLING_INFORMATION_SUCCESS;

  constructor(public payload: BillingInformation) {}
}

export class UpdateBillingInformationFailureAction implements Action {
  readonly type = UPDATE_BILLING_INFORMATION_FAILURE;

  constructor(public payload: any) {}
}

export class UpdateBillingInformationAction implements Action {
  readonly type = UPDATE_BILLING_INFORMATION;

  constructor(public payload: BillingInformation) {}
}

export type BillingAction =
  | GetBillingInformationAction
  | GetBillingInformationSuccessAction
  | GetBillingInformationFailureAction
  | UpdateBillingInformationSuccessAction
  | UpdateBillingInformationFailureAction
  | UpdateBillingInformationAction;
